import api from 'api';

import { PUBLIC_SCREEN_PERMISSION } from '@gogame/screens';

export const loadCurrentUser = api('GET /api/auth/current');

export const impersonate = api('POST /api/impersonate');
export const dismissImpersonate = api('POST /api/impersonate/dismiss');
export const loadCookie = api('GET /api/auth/cookie');

export const loadCurrentPermissions = async (params) => {
  const permissions = await api('GET /api/auth/permissions')(params);

  return {
    actions: permissions.actionIds,
    pages: [PUBLIC_SCREEN_PERMISSION, ...permissions.pageIds],
  };
};
